
import request, { IWorkspaceResponse } from './http/request'
import Xrequest from './http/Xrequest '

const API_PREFIX = '/manage/api/v1'

export interface objectData {
    path: string
    file: File
}

// 上传文件并获取objectKey
export const getObjectKey = async function (body: objectData): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/files/upload-file`
  const result = await request.post(url, body)
  return result.data
}

// 上传文件到中台并获取objectKey
export const getObjectKeyUav = async function (body: objectData): Promise<IWorkspaceResponse<any>> {
  const url = '/minio-file/upload-file'
  const result = await Xrequest.post(url, body)
  return result.data
}

export interface holdEvent {
    type: number // 警戒值，0-已下全部满足，1-以下满足其一即可
    value: number // 数值
    remark: string // 备注
    detect_type: string // 事件对象类型
    detect_target_name: string // 对象目标名称
    sensitive_words: string // 敏感词
}

export interface AlarmEventParam {
    id: string // 事件id
    speak: boolean // 是否喊话，0-否，1-是
    remark: string // 备注
    thresholds: holdEvent // 算法告警事件阈值参数实体
    event_name: string // 事件名称
    algorithm_id: string // 算法id
    screen_shot: boolean // 是否截图，0-否，1-是
    screen_shot_notify_object_key: string // 截图文件objectKey
    speak_detail: string // 喊话内容
    speak_notify_object_key: string // 喊话文件objectKey
    light: boolean // 是否警灯爆闪,0-闪，1-是
    alarm_light: number // 警灯爆闪,0- 红蓝爆闪 ,1- 红蓝快闪/红红爆闪 ,2- 蓝蓝爆闪 ,3- 红红爆闪/黄黄爆闪
    silent_time: number // 告警间隔
    video_slice: boolean // 是否视频切片，0-否，1-是
    video_slice_silent_time: number // 视频切片时长
}

// 添加算法告警事件
export const addAlarmEvent = async function (body: AlarmEventParam): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/algorithm/save-or-update-algorithm-alarm-event`
  const result = await request.post(url, body)
  return result.data
}

// 分页参数
export interface alarmQueryParam {
    algorithm_id: string // 算法ID
    event_name: string // 事件名称
}

export interface alarmPageRequest {
    page: number
    page_size: number
    param: alarmQueryParam
}

// 算法告警事件分页
export const getAlarmEvent = async function (body: alarmPageRequest): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/algorithm/algorithm-alarm-event-page`
  const result = await request.post(url, body)
  return result.data
}

// 算法告警事件详情
export const getAlarmEventData = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/algorithm/get-algorithm-alarm-event-by-id/${id}`
  const result = await request.get(url)
  return result.data
}

// 删除告警事件
export const deleteAlarmEvent = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/algorithm/delete-algorithm-alarm-event/${id}`
  const result = await request.delete(url)
  return result.data
}

// 根据设备sn获取设备关联的算法
export const getAlgorithmByDeviceSn = async function (deviceSn: string, algorithmType: string): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/devices/devices/list-device-algorithm/${deviceSn}/${algorithmType}`
  const result = await request.get(url)
  return result.data
}
